export const camelCaseToPascalCase = (input: string) => {
  return input.charAt(0).toUpperCase() + input.substr(1);
};
